module.exports = __webpack_public_path__ + "static/media/communication.7f020193.jpg";